

.subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

.field-with-text {
  display: flex;
  align-items: center;

  gz-text {
    margin-left: 50px;
    padding-bottom: 20px;
  }
}

gz-textarea {
  max-width: 640px;
}

gz-chips-generator-input {
  --chip-list-width: 900px;
  --form-field-with-floating-max-width: 860px;
}

#exchange-content-control-attachment-enable-field {
  .content {
    span {
      font-size: var(--header-font-size);
      font-weight: 500;
    }
  }
}
